import React from 'react';
import Registration from "../components/salescenter/registration/Registration";
import RegisterResponse from "../components/salescenter/registration/RegisterResponse";
import ProtectedRoute from "./ProtectedRoute";

export default [
    <ProtectedRoute path="/sales/activate" component={Registration} exact key="register"/>,
    <ProtectedRoute path="/sales/activate/response" component={RegisterResponse} exact key="register-response"/>,
];
